import { useEffect } from 'react';
import EventoServer from '../libs/EventoServer';

const useSignalR = (event, callback) => {
  useEffect(() => {
    EventoServer.subscribe(event, callback);
    return () => {
      EventoServer.unsubscribe(event, callback);
    };
  }, [callback, event]);
};

export default useSignalR;
